const TypedMap = {
    '[object Date]': cloneDate,
    '[object ArrayBuffer]': cloneArrayBuffer,
    '[object DataView]': cloneDataView,
    '[object Float32Array]': cloneTypedArray,
    '[object Float64Array]': cloneTypedArray,
    '[object Int8Array]': cloneTypedArray,
    '[object Int16Array]': cloneTypedArray,
    '[object Int32Array]': cloneTypedArray,
    '[object Uint8Array]': cloneTypedArray,
    '[object Uint8ClampedArray]': cloneTypedArray,
    '[object Uint16Array]': cloneTypedArray,
    '[object Uint32Array]': cloneTypedArray,
    '[object RegExp]': cloneRegExp,
    '[object Map]': cloneMap
};
const TypedArrayMap = {
    '[object Float32Array]': Float32Array,
    '[object Float64Array]': Float64Array,
    '[object Int8Array]': Int8Array,
    '[object Int16Array]': Int16Array,
    '[object Int32Array]': Int32Array,
    '[object Uint8Array]': Uint8Array,
    '[object Uint16Array]': Uint16Array,
    '[object Uint32Array]': Uint32Array,
    '[object Uint8ClampedArray]': Uint8ClampedArray
};
function cloneArrayBuffer(arrayBuffer) {
    const result = new ArrayBuffer(arrayBuffer.byteLength);
    new Uint8Array(result).set(new Uint8Array(arrayBuffer));
    return result;
}
function cloneDate(targetDate) {
    return new Date(targetDate.getTime());
}
function cloneDataView(dataView) {
    return new DataView(cloneArrayBuffer(dataView.buffer), dataView.byteOffset, dataView.byteLength);
}
function cloneTypedArray(typedArray) {
    return new TypedArrayMap[Object.prototype.toString.call(typedArray)](cloneArrayBuffer(typedArray.buffer), typedArray.byteOffset, typedArray.length);
}
function cloneRegExp(targetRegexp) {
    const result = new RegExp(targetRegexp.source, targetRegexp.flags);
    result.lastIndex = targetRegexp.lastIndex;
    return result;
}
function cloneMap(targetMap) {
    const map = new Map();
    targetMap.forEach((value, key) => map.set(deepCopy(key), deepCopy(value)));
    return map;
}
export function deepCopy(target) {
    const tag = Object.prototype.toString.call(target);
    if (TypedMap[tag]) {
        return TypedMap[tag](target);
    }
    if (target === null) {
        return target;
    }
    if (Array.isArray(target)) {
        return target.map(n => deepCopy(n));
    }
    if (target && typeof target === 'object') {
        return Object.entries(target).reduce((acc, [key, value]) => {
            acc[key] = deepCopy(value);
            return acc;
        }, {});
    }
    return target;
}
